import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/common/Button';
import { Card, CardHeader, CardContent } from '../../components/common/Card';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Use browser history to go back
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback to dashboard if no history
      navigate('/dashboard');
    }
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900">Access Denied</h1>
          <p className="mt-2 text-sm text-gray-600">
            You don't have permission to access this resource
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="shadow-lg">
          <CardHeader className="space-y-1">
            <div className="text-center">
              <div className="text-6xl mb-4" aria-hidden="true">
                🚫
              </div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Unauthorized Access
              </h2>
            </div>
          </CardHeader>
          
          <CardContent>
            <div className="text-center space-y-4">
              <p className="text-gray-600">
                You don't have the required permissions to access this page.
                Please contact your administrator if you believe this is an error.
              </p>
              
              <div className="space-y-2">
                <Button
                  onClick={handleGoBack}
                  variant="primary"
                  className="w-full"
                >
                  Go Back
                </Button>
                
                <Button
                  onClick={handleGoToDashboard}
                  variant="secondary"
                  className="w-full"
                >
                  Go to Dashboard
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
